import {
    get_tipi_disegno,
    create_tipo_disegno,
    update_tipo_disegno,
    delete_tipo_disegno,
    crea_parametro_disegno,
    aggiorna_parametro_disegno,
    elimina_parametro_disegno,
} from "@/api/api.tipiDisegno.js";

const tipiDisegno = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipi_disegno().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_tipo_disegno(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_tipo_disegno(id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipo_disegno(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        creaParametro({ dispatch }, { tipoDisegnoId, dati }) {
            return new Promise((resolve, reject) => {
                crea_parametro_disegno(tipoDisegnoId, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiornaParametro({ dispatch }, { tipoDisegnoId, id, dati }) {
            return new Promise((resolve, reject) => {
                aggiorna_parametro_disegno(tipoDisegnoId, id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        eliminaParametro({ dispatch }, { tipoDisegnoId, id }) {
            return new Promise((resolve, reject) => {
                elimina_parametro_disegno(tipoDisegnoId, id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipiDisegno;
